import { render } from "./ImageCopyright.vue?vue&type=template&id=7a23edd0&scoped=true"
import script from "./ImageCopyright.vue?vue&type=script&lang=ts"
export * from "./ImageCopyright.vue?vue&type=script&lang=ts"

import "./ImageCopyright.vue?vue&type=style&index=0&id=7a23edd0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7a23edd0"

export default script